import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { BookAssignment } from 'bookraw/shared/models/book-assignment.model';
import { HttpHeaders } from '@angular/common/http';
import { environment } from 'env/environment';


@Injectable()
export class BookAssignsService extends ListService<BookAssignment> {
  url: string = '/api/admin/bookAssigns';

  export() {
    const tmpQuery = this.queryParams;
    tmpQuery.setQueryParam('limit', null);
    tmpQuery.setQueryParam('offset', null);

    const headers = new HttpHeaders().set('Accept', ['application/json', 'application/vnd.ms-excel']);
    return this.http.get(environment.baseURL + this.url + '/export' + tmpQuery.paramString, {
      headers, observe: 'response', responseType: 'blob'
    });
  }
}
